module.exports = __webpack_public_path__ + "img/9-7-2022_estrellas_thumb.5db70a45.jpg";